import { Immer } from "immer";
import { immer } from "zustand/middleware/immer";

interface ReadyToBillFilterState {
  readyToBillFilter: {
    customerId: string | null;
    contractId: string[];
    serviceType: string[];
    billStatus: string[];
  };
  readyToBillFixedFilter: {
    customerId: string | null;
    contractId: string | null;
    serviceType: string[];
    billStatus: string[];
  };
}

interface ReadyToBillFilterAction {
  setReadyToBillFilterData: ({
    type,
    value,
  }: {
    type: "customerId" | "contractId" | "serviceType" | "billStatus";
    value: string | string[] | null;
    contractType: "actual" | "fixed";
  }) => void;
}

export interface ReadyToBillFilterInterface
  extends ReadyToBillFilterAction,
    ReadyToBillFilterState {}

export const readyToBillFilterSlice = immer<
  ReadyToBillFilterState & ReadyToBillFilterAction
>((set, get) => ({
  readyToBillFilter: {
    customerId: null,
    contractId: [],
    serviceType: [],
    billStatus: [],
  },
  readyToBillFixedFilter: {
    customerId: null,
    contractId: null,
    serviceType: [],
    billStatus: [],
  },

  setReadyToBillFilterData: ({ type, value, contractType }) =>
    set((state) => {
      if (type === "customerId") {
        // @ts-expect-error
        state.readyToBillFilter.customerId = value;
        // @ts-expect-error
        state.readyToBillFixedFilter.customerId = value;

        state.readyToBillFilter.contractId = [];
        state.readyToBillFixedFilter.contractId = null;
      } else {
        if (contractType === "actual") {
          // @ts-expect-error
          state.readyToBillFilter[type] = value;
        } else {
          // @ts-expect-error
          state.readyToBillFixedFilter[type] = value;
        }
      }
    }),
}));
